import React, { Component } from 'react';
import { connect } from 'react-redux';
import { slice } from 'lodash';
import {
    triggerPlayerSkillsFilter
} from '../../../actions/FormationActions';
import common from '../../../common';
import config from '../../../config'

class PlayerSkillsFilterWeb extends Component {
    constructor(props) {
        super(props);
        this.playerSkillsArray = config.skillsFilterWeb;
    }

    // componentDidMount() {
    //     this.props.applySkillFilter(skills.map)
    // }
    onSkillsSelect = (skills) => {
        if (this.props.playerFiltersSkills.indexOf(skills.map) > -1) {
            //to be removed
        } else {
            common.customTracking('Select Position filter - ' + skills.skill,common.getPageName());
        }
        this.props.applySkillFilter(skills.map)

    }


    render() {
        let trans = this.props.trans;
        let self = this;

        return <div className="si-pos-filter si-more-filters si-flexBox">


            { self.playerSkillsArray.map((skills) => {
                const clickableClass = common.makeClasses({
                    'si-sort-option': true,
                    'si-selected': self.props.playerFiltersSkills.indexOf(skills.map) > -1
                });
                const toggleSkill = { onClick: () => this.onSkillsSelect(skills) };
                return <div className="si-sort-box"  { ...toggleSkill } key={ skills.map }>
                    <div className={ clickableClass }>
                        { trans[skills.key + "_short"] ? trans[skills.key + "_short"] : skills.key }
                        <span className="si-sort-tick si-flexBox"></span>
                    </div>
                </div>
            }) }
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        sortByArr: state.formationData.sortByArr,
        isSortByOpenForWeb: state.formationData.isSortByOpenForWeb,
        sortBy: state.formationData.playerFilters.sortBy,
        playerFiltersSkills: state.formationData.playerFilters.skillId
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        applySkillFilter: (skill) => dispatch(triggerPlayerSkillsFilter(skill))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PlayerSkillsFilterWeb);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/playerSkillsFilterWeb.js